export const PUBLIC_CHAT_CONFIG = {
  messageMaxLength: 200,
};

export const PRIVATE_CHAT_CONFIG = {
  messageMaxLength: 3000,
};
